var map = {
	"./logo-alphabet.svg": 5213,
	"./logo-amazon-2.svg": 5214,
	"./logo-amazon.svg": 5215,
	"./logo-azercell.svg": 5216,
	"./logo-bank-of-america.svg": 5217,
	"./logo-barclays.svg": 5218,
	"./logo-bbc.svg": 5219,
	"./logo-bnp-paribas.svg": 5220,
	"./logo-booking.svg": 5221,
	"./logo-citibank.svg": 5222,
	"./logo-coca-cola.svg": 5223,
	"./logo-deloitte.svg": 5224,
	"./logo-experian.svg": 5225,
	"./logo-facebook.svg": 5226,
	"./logo-g.svg": 5227,
	"./logo-goldman-sachs.svg": 5228,
	"./logo-google.svg": 5229,
	"./logo-h.svg": 5230,
	"./logo-henkel.svg": 5231,
	"./logo-hsbc.svg": 5232,
	"./logo-ikea.svg": 5233,
	"./logo-infineon.svg": 5234,
	"./logo-instagram.svg": 5235,
	"./logo-jp-morgan.svg": 5236,
	"./logo-jti.svg": 5237,
	"./logo-linkedin.svg": 5238,
	"./logo-meta.svg": 5239,
	"./logo-morgan-stanley.svg": 5240,
	"./logo-netflix.svg": 5241,
	"./logo-oracle.svg": 5242,
	"./logo-paypal.svg": 5243,
	"./logo-pwc-new.svg": 5244,
	"./logo-pwc.svg": 5245,
	"./logo-spotify.svg": 5246,
	"./logo-tesla.svg": 5247,
	"./logo-visa.svg": 5248,
	"./logo-walmart.svg": 5249,
	"./logo-youtube.svg": 5250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5212;